<section id="education">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1>Index Funds: The 12-Step Recovery Program for Active Investors</h1>
            </div>
        </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-sm-3">
            <iframe style="width:100%; height:383px;" src="//e.issuu.com/embed.html#25528146/36924572" frameborder="0" allowfullscreen=""></iframe>
        </div>
        <div class="col-sm-9">
          <p>Mark Hebner is on a mission to change the way the world invests — by replacing speculation with education. With that in mind, this little gem packs hard data and hundreds of unique and colorful paintings, charts and graphs portraying historic stock market data all the way back to 1928. This is a quick, intelligent read and arguably the most artistic book ever written on investing.</p>
          
          <hr class="mb-3">
          <div class="share-link">
              <img src="/images//icon_bookmark.png"><span> Read the Book (Click the Fullscreen button)</span>
          </div>
          <hr class="mb-3">
          <div class="share-link">
              <img src="/images//icon_com.png"><span> Call or <a href="mailto:info@ifa.com?subject=I%20want%20my%20free%20copy&amp;body=Please%20send%20me%20my%20free%20copy%20of%3A%0A%20%0A%0AIndex%20Funds%3A%20The%2012-Step%20Recovery%20Program%20For%20Active%20Investors%0A%0AName%3A%0AMailing%20Address%3A%0APhone%20Number%3A">Email</a> for Your Copy (888.643.3133)</span>
          </div>
          <hr class="mb-3">
          <div class="share-link">
                      <a href="https://www.amazon.com/gp/product/0976802317?ie=UTF8&amp;tag=ifacom-20&amp;linkCode=xm2&amp;camp=1789&amp;creativeASIN=0976802317" target="_blank">
                          <img src="/images/amazon_button.png" height="" width="150"></a>
          </div>
        </div>
        
        </div>
      </div>
  </section>